// extracted by mini-css-extract-plugin
export var button = "_jn-0";
export var donut = "_jn-1";
export var donutFill = "_jn-3";
export var donutTrack = "_jn-2";